// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__11_i-","title":"Images45_title__2arkR","images":"Images45_images__y2pC9"};